import styled from "styled-components";
import { MuiBox } from "../../../../components";
import { responsive } from "../../../../styles/constants.style";

export const MdmOfficeViewModalWrapper = styled(MuiBox)`
  display: flex;
  flex-direction: column;
  gap: 32px;
  .container-box {
    margin: 24px;
    ${responsive.MOBILE`
          margin: 16px;
        `}
  }
  .container-header {
    margin-bottom: 16px;
  }
  .configuration-container {
    margin-top: 0;
  }
`;
